export function updateInjectedComponents(injected) {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_INJECTED_COMPONENTS',
      injected,
    })
  }
}
